import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

// 創建一個自訂的行業選擇器標籤雲
const IndustryTagCloud = ({ industries, selectedIndustry, onSelectIndustry }) => {
  return (
    <Box 
      sx={{ 
        py: 2, 
        px: 1,
        backgroundColor: '#f8f9fa',
        borderRadius: 2,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        justifyContent: 'center',
        boxShadow: 'inset 0 0 5px rgba(0,0,0,0.1)'
      }}
    >
      {industries.map((industry) => (
        <Chip
          key={industry.id}
          icon={<Typography component="span">{industry.icon}</Typography>}
          label={industry.name}
          onClick={() => onSelectIndustry(industry)}
          color={selectedIndustry.id === industry.id ? "primary" : "default"}
          variant={selectedIndustry.id === industry.id ? "filled" : "outlined"}
          sx={{ 
            m: 0.5,
            borderColor: selectedIndustry.id === industry.id ? industry.color : '#e0e0e0',
            backgroundColor: selectedIndustry.id === industry.id ? industry.color : 'transparent',
            '&:hover': {
              backgroundColor: selectedIndustry.id === industry.id ? industry.color : '#e8e8e8',
            },
            transition: 'all 0.3s ease',
            '& .MuiChip-label': {
              fontSize: '18px',  // 增加標籤文字的字體大小到16px
              padding: '0 12px', // 增加內邊距以適應更大的文字
            },
            height: 'auto',      // 允許高度自適應
            paddingTop: '6px',   // 增加上下內邊距
            paddingBottom: '6px' // 確保標籤有足夠空間
          }}
        />
      ))}
    </Box>
  );
};

export default IndustryTagCloud;